import { FormControlLabel, Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import BSInput from "../../../common/js/components/BSInput";
import MultiAddInput from "../../../common/js/components/MultiAddInput";
import "./Portfolio.css";
import PortfolioPropertyDetail from "./PortfolioPropertyDetail";

const StyledSwitchTitle = styled("span")({
    fontSize: 14,
    fontWeight: 600,
});

const StyledTheSwitch = styled(Switch)({
    marginRight: 0,
});

const PortfolioForm = (props) => {
    const {
        data,
        dataPathPrefix,
        disableInputs,
        errors,
        handleAddArrayElement,
        handleDeleteArrayElement,
        handleUpdateArrayElement,
        onChange,
    } = props;

    return (
        <div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>
                    <StyledSwitchTitle>Portfolio Information</StyledSwitchTitle>
                </div>
                <div>
                    <FormControlLabel
                        control={
                            <StyledTheSwitch
                                checked={data.portfolioFlg === true ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                color="primary"
                                value="portfolioFlg"
                                disabled={disableInputs}
                            />
                        }
                    />
                </div>
            </div>
            {data.portfolioFlg && (
                <div>
                    <BSInput
                        id="portfolioName"
                        extraInputStyles={{ marginRight: "34px" }}
                        label="Portfolio"
                        disabled={disableInputs}
                        placeholder="Enter name"
                        error={errors.portfolioName}
                        value={data.portfolioName}
                        onChange={(e) => onChange(e.target.id, e.target.value)}
                    />
                    <MultiAddInput
                        addButtonText="Add Portfolio Property"
                        disableInputs={disableInputs}
                        displayFirstWhenEmpty={true}
                        elements={data.portfolioProperties}
                        onAdd={() => handleAddArrayElement(dataPathPrefix + ".portfolioProperties")}
                        onUpdate={(e, index) =>
                            handleUpdateArrayElement(
                                dataPathPrefix + ".portfolioProperties",
                                index,
                                e.target.id,
                                e.target.value
                            )
                        }
                        render={(element, elementIndex) => (
                            <PortfolioPropertyDetail
                                element={element}
                                elementIndex={elementIndex}
                                onDelete={(index) =>
                                    handleDeleteArrayElement(dataPathPrefix + ".portfolioProperties", index)
                                }
                                {...props}
                            />
                        )}
                    />
                </div>
            )}
        </div>
    );
};

export default PortfolioForm;
